/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateTypesByEngineType {
    getFixupPrototypeFunction() { return TemplateTypesByEngineType.fixupPrototype; }

    static newInstance(model: Partial<TemplateTypesByEngineType>): TemplateTypesByEngineType {
        let obj = Object.assign(new TemplateTypesByEngineType(), model);
        TemplateTypesByEngineType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateTypesByEngineType>): TemplateTypesByEngineType {
        if (!model) return null;
        return TemplateTypesByEngineType.newInstance(<TemplateTypesByEngineType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateTypesByEngineType) {
        if (!obj) return;

        models.TemplateTypesByEngineType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateTypesByEngineType): boolean {
        Object.setPrototypeOf(obj, TemplateTypesByEngineType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Types selected under the terraform engine
     */
    terraform: Array<models.TerraformTemplateType>;

    /**
     * Types selected under the cfn engine
     */
    cfn: Array<models.CfnTemplateType>;

    /**
     * Types selected under the arm engine
     */
    arm: Array<models.ArmTemplateType>;

    /**
     * Types selected under the dm engine
     */
    dm: Array<models.DmTemplateType>;

    /**
     * Types selected under the mistral engine
     */
    mistral: Array<models.MistralTemplateType>;

}
